import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, ShoppingBag } from 'lucide-react';
const PURCHASES = [{
  name: 'María',
  city: 'Buenos Aires',
  time: '3 minutos'
}, {
  name: 'Luciana',
  city: 'Córdoba',
  time: '5 minutos'
}, {
  name: 'Camila',
  city: 'Rosario',
  time: '8 minutos'
}, {
  name: 'Florencia',
  city: 'Mendoza',
  time: '2 minutos'
}, {
  name: 'Agustina',
  city: 'La Plata',
  time: '12 minutos'
}, {
  name: 'Sofía',
  city: 'Tucumán',
  time: '6 minutos'
}, {
  name: 'Daniela',
  city: 'Santa Fe',
  time: '4 minutos'
}, {
  name: 'Romina',
  city: 'Salta',
  time: '9 minutos'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Loop interval
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomIndex = Math.floor(Math.random() * PURCHASES.length);
        setCurrentPurchase(PURCHASES[randomIndex]);
        setIsVisible(true);
      }, 2000); // Wait 2s before showing next one
    }, 12000); // Show every 12 seconds
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-213">
      {isVisible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 100,
      damping: 20
    }} className="fixed bottom-4 left-4 z-40 bg-white rounded-lg shadow-2xl border-l-4 border-green-500 p-4 max-w-xs md:max-w-sm flex items-center gap-3" data-id="element-214">
          <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-215">
            <ShoppingBag className="w-6 h-6 text-green-600" data-id="element-216" />
          </div>
          <div data-id="element-217">
            <p className="text-sm font-bold text-gray-900" data-id="element-218">
              {currentPurchase.name} de {currentPurchase.city}
            </p>
            <p className="text-xs text-gray-600" data-id="element-219">
              compró el MegaPack hace {currentPurchase.time}
            </p>
            <div className="flex items-center gap-1 mt-1" data-id="element-220">
              <CheckCircle className="w-3 h-3 text-green-500" data-id="element-221" />
              <span className="text-[10px] text-gray-500 font-medium" data-id="element-222">
                Verificado por Solución Store
              </span>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}